function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 10.5,
  r: 6.75,
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9,
  r: 2.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 15C4.66667 14.1667 5.5 12 9.5 12C13.5 12 14.3333 14.1667 14.5 15",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/contact.c202701a.svg";
export { SvgComponent as ReactComponent };